<!-- 数据列表（客商 参展报告） -->
<template>
  <div v-loading='pageLoading'>
      <!--客商 收藏的数据 -->
      <div class="v-report-block">
        <div class="v-report-title v-clearfix">
          <div class="v-report-text">{{$t('collectedStatistics')}}</div>
          <div class="v-report-form">
            <el-date-picker
              size="small"
              v-model="listForm.collect"
              value-format="yyyy-MM-dd HH:mm:ss"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              :picker-options="endDatePicker()"
              @change="dataPickerChange('collect')"
              type="datetimerange">
            </el-date-picker>
          </div>
        </div>
        <div class="v-report-subTitle">{{$t('subTitle2')}}</div>
        <div class="v-report-body v-clearfix">
          <div class="v-report-data" :class="{'on': controlList.collect == 1}" @click="controlTodo('collect', 1, 'collect1')">
            <div class="v-repot-data__title">{{$t('collectedActorNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('collectedActorNumSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.collect['1']}}</span>
              <span class="num2">{{$t('unit5')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.collect == 2}" @click="controlTodo('collect', 2, 'collect2')">
            <div class="v-repot-data__title">{{$t('collectedExhibitsNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('collectedExhibitsNumSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.collect['2']}}</span>
              <span class="num2">{{$t('unit5')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="v-report-table" v-loading="loading['collect']">
          <div class="v-report-table__block" v-show="controlList.collect == 1">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('actorListText')}}</div>
                  <div class="search-exhibits-wrap">
                    <div class="search-input">
                      <el-input v-model="searchForm.collect['1']" :placeholder="$t('reportPlaceholder5')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('collect', 1)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('collect')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportData('collect')" :disabled="total.collect == 0">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="collect1"
                :type="'collect'"
                :data="table.collect"
                :total="total.collect"
                :page="currentPage.product"
                :pageSize="pagination.pageSize"
                :fields="fields.actor"
                :hideFileds="['visitNum']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="lookDetail(scope.data.row, 'actor')" type="text" size="small">{{$t('lookDetail')}}</el-button>
                  </template>
                </VisitorData>
          </div>
          <div class="v-report-table__block" v-show="controlList.collect == 2">
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="text">{{$t('productListText')}}</div></div>
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input">
                      <el-input v-model="searchForm.collect['2']" :placeholder="$t('reportPlaceholder6')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('collect', 2)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('collect')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini"  @click="exportData('collect')" :disabled="total.collect == 0">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="collect2"
                :data="table.collect"
                :total="total.collect"
                :page="currentPage.collect"
                :type="'collect'"
                :pageSize="pagination.pageSize"
                :fields="fields.product"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="hProductImgVideo-action" slot-scope="scope">
                    <template v-if="scope.data.row.icon">
                      <template v-for="(url, index) in scope.data.row.icon.split(',')">
                        <el-image style="margin-right: 5px; width: 30px; height: 30px;" v-if="index <= 2" :key="url" :src="$funcs.compressImage(url, 30, 30)"></el-image>
                      </template>
                    </template>
                    <template v-else>--</template>
                  </template>
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="lookDetail(scope.data.row, 'product')" type="text" size="small">{{$t('lookDetail')}}</el-button>
                  </template>
                </VisitorData>
          </div>
      </div>

      <!--客商 浏览统计-->
      <div class="v-report-block">
        <div class="v-report-title v-clearfix">
          <div class="v-report-text">{{$t('visitStatistics')}}</div>
          <div class="v-report-form">
            <el-date-picker
              size="small"
              v-model="listForm.browse"
              value-format="yyyy-MM-dd HH:mm:ss"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              :picker-options="endDatePicker()"
              @change="dataPickerChange('browse')"
              type="datetimerange">
            </el-date-picker>
          </div>
        </div>
        <div class="v-report-subTitle">{{$t('subTitle2')}}</div>
        <div class="v-report-body v-clearfix">
          <div class="v-report-data" :class="{'on': controlList.browse == 1}" @click="controlTodo('browse', 1, 'browse1')">
            <div class="v-repot-data__title">{{$t('visitActorNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('visitActorNumSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.browse['1']}}</span>
              <span class="num2">{{$t('unit5')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.browse == 2}" @click="controlTodo('browse', 2, 'browse2')">
            <div class="v-repot-data__title">{{$t('visitExhibitNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('visitExhibitNumSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.browse['2']}}</span>
              <span class="num2">{{$t('unit5')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="v-report-table" v-loading="loading['browse']">
          <div class="v-report-table__block" v-show="controlList.browse == 1">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('actorListText')}}</div>
                  <div class="search-exhibits-wrap">
                    <div class="search-input">
                      <el-input v-model="searchForm.browse['1']" :placeholder="$t('reportPlaceholder5')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('browse', 1)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('browse')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportData('browse')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="browse1"
                :type="'browse'"
                :data="table.browse"
                :total="total.browse"
                :page="currentPage.browse"
                :pageSize="pagination.pageSize"
                :fields="fields.actor"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="lookDetail(scope.data.row, 'actor')" type="text" size="small">{{$t('lookDetail')}}</el-button>
                  </template>
                </VisitorData>
          </div>
          <div class="v-report-table__block" v-show="controlList.browse == 2">
              <div class="report-todo v-clearfix">
                <div class="title">
                  <div class="text">{{$t('productListText')}}</div></div>
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input">
                      <el-input v-model="searchForm.browse['2']" :placeholder="$t('reportPlaceholder6')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('browse', 2)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('browse')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportData('browse')" :disabled="total.browse == 0">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="browse2"
                :data="table.browse"
                :total="total.browse"
                :page="currentPage.browse"
                :type="'browse'"
                :pageSize="pagination.pageSize"
                :fields="fields.product"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="hProductImgVideo-action" slot-scope="scope">
                    <template v-if="scope.data.row.icon">
                      <template v-for="(url, index) in scope.data.row.icon.split(',')">
                        <el-image style="margin-right: 5px; width: 30px; height: 30px;" v-if="index <= 2" :key="url" :src="$funcs.compressImage(url, 30, 30)"></el-image>
                      </template>
                    </template>
                    <template v-else>--</template>
                  </template>
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="lookDetail(scope.data.row, 'product')" type="text" size="small">{{$t('lookDetail')}}</el-button>
                  </template>
                </VisitorData>
          </div>
      </div>

      <!--客商 商脉圈统计-->
      <div class="v-report-block">
        <div class="v-report-title v-clearfix">
          <div class="v-report-text">{{$t('opporStatistics')}}</div>
          <div class="v-report-form">
            <el-date-picker
              size="small"
              v-model="listForm.opportunity"
              value-format="yyyy-MM-dd HH:mm:ss"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              :picker-options="endDatePicker()"
              @change="dataPickerChange('opportunity')"
              type="datetimerange">
            </el-date-picker>
          </div>
        </div>
        <div class="v-report-subTitle">{{$t('subTitle3')}}</div>
        <div class="v-report-body v-clearfix">
          <div class="v-report-data" :class="{'on': controlList.opportunity == 1}" @click="controlTodo('opportunity', 1, 'opportunity1')">
            <div class="v-repot-data__title">{{$t('oppNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('oppNumVisitorSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.opportunity['1']}}</span>
              <span class="num2">{{$t('unit3')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.opportunity == 2}" @click="controlTodo('opportunity', 2, 'opportunity2')">
            <div class="v-repot-data__title">{{$t('comment')}}</div>
            <div class="v-repot-data__subTitle">{{$t('commentSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.opportunity['2']}}</span>
              <span class="num2">{{$t('unit3')}}</span>
            </div>
          </div>
          <div class="v-report-data" :class="{'on': controlList.opportunity == 3}" @click="controlTodo('opportunity', 3, 'opportunity3')">
            <div class="v-repot-data__title">{{$t('thumbsUp')}}</div>
            <div class="v-repot-data__subTitle">{{$t('thumbsUpSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.opportunity['3']}}</span>
              <span class="num2">{{$t('unit6')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="v-report-table" v-loading="loading['opportunity']">
          <div class="v-report-table__block" v-show="controlList.opportunity == 1">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('oppListText')}}
                    <span>{{$t('dataListSubTitle6')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.opportunity['1']" :placeholder="$t('reportPlaceholder3')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('opportunity', 1)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('opportunity')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportData('opportunity')" :disabled="total.opportunity == 0">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="opportunity1"
                :type="'opportunity'"
                :data="table.opportunity"
                :total="total.opportunity"
                :page="currentPage.opportunity"
                :pageSize="pagination.pageSize"
                :fields="fields.opportunity1"
                :hideFileds="['action']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="url-action" slot-scope="scope">
                    <template v-if="scope.data.row.url">
                      <template v-for="(url, index) in scope.data.row.url.split(',')">
                        <el-image style="margin-right: 5px; width: 30px; height: 30px;" v-if="index <= 2" :key="url" :src="$funcs.compressImage(url, 30, 30)"></el-image>
                      </template>
                    </template>
                    <template v-else>--</template>
                  </template>
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'opportunity', 1)" type="text" size="small">{{$t('actorListText')}}</el-button>
                  </template>
                </VisitorData>
          </div>
          <div class="v-report-table__block" v-show="controlList.opportunity == 2">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('oppListText')}}
                    <span>{{$t('dataListSubTitle6')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.opportunity['2']" :placeholder="$t('reportPlaceholder3')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('opportunity', 2)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('opportunity')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportData('opportunity')" :disabled="total.opportunity == 0">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="opportunity2"
                :data="table.opportunity"
                :total="total.opportunity"
                :page="currentPage.opportunity"
                :type="'opportunity'"
                :pageSize="pagination.pageSize"
                :fields="fields.opportunity1"
                :hideFileds="['likeTotal']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="url-action" slot-scope="scope">
                    <template v-if="scope.data.row.url">
                      <template v-for="(url, index) in scope.data.row.url.split(',')">
                        <el-image style="margin-right: 5px; width: 30px; height: 30px;" v-if="index <= 2" :key="url" :src="$funcs.compressImage(url, 30, 30)"></el-image>
                      </template>
                    </template>
                    <template v-else>--</template>
                  </template>
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'opportunity', 2)" type="text" size="small" v-if="scope.data.row.commentNum">{{$t('actorListText')}}</el-button>
                  </template>
                </VisitorData>
          </div>
          <div class="v-report-table__block" v-show="controlList.opportunity == 3">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('oppListText')}}
                    <span>{{$t('dataListSubTitle6')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.opportunity['3']" :placeholder="$t('reportPlaceholder3')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('opportunity', 3)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('opportunity')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportData('opportunity')" :disabled="total.opportunity == 0">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="opportunity3"
                :data="table.opportunity"
                :total="total.opportunity"
                :page="currentPage.opportunity"
                :type="'opportunity'"
                :pageSize="pagination.pageSize"
                :fields="fields.opportunity1"
                :hideFileds="['commentNum']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="url-action" slot-scope="scope">
                    <template v-if="scope.data.row.url">
                      <template v-for="(url, index) in scope.data.row.url.split(',')">
                        <el-image style="margin-right: 5px; width: 30px; height: 30px;" v-if="index <= 2" :key="url" :src="$funcs.compressImage(url, 30, 30)"></el-image>
                      </template>
                    </template>
                    <template v-else>--</template>
                  </template>
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'opportunity', 3)" type="text" size="small" v-if="scope.data.row.likeTotal">{{$t('actorListText')}}</el-button>
                  </template>
                </VisitorData>
          </div>
      </div>

      <!--客商 邀约统计-->
      <div class="v-report-block">
        <div class="v-report-title v-clearfix">
          <div class="v-report-text">{{$t('inviteStatistics')}}</div>
          <div class="v-report-form">
            <el-date-picker
              size="small"
              v-model="listForm.invite"
              value-format="yyyy-MM-dd HH:mm:ss"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              :picker-options="endDatePicker()"
              @change="dataPickerChange('invite')"
              type="datetimerange">
            </el-date-picker>
          </div>
        </div>
        <div class="v-report-subTitle">{{$t('subTitle4')}}</div>
        <div class="v-report-body v-clearfix">
          <div class="v-report-data" :class="{'on': controlList.invite == 1}" @click="controlTodo('invite', 1, 'invite1')">
            <div class="v-repot-data__title">{{$t('sendInviteNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('sendInviteNumSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.invite['1']}}</span>
              <span class="num2">{{$t('unit3')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="v-report-table" v-loading="loading['invite']">
          <div class='v-report-table__block' v-show="controlList.invite == 1">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('inviteListText')}}
                    <span>{{$t('dataListSubTitle7')}}</span>
                  </div>
                </div>
              </div>
              <div class="auditStatus bl-container" style="width: 100%; max-width: 100%">
                <el-radio-group v-model="scope" @change="stateChange('invite', '1')">
                  <el-radio label="" border>{{$t('common.all')}}({{modularDateNum['invite']['1']}})</el-radio>
                  <el-radio label="APPROVE" border>{{$t('common.confirmedText')}}({{inviteData['approveCount']}})</el-radio>
                  <el-radio label="PENDING" border>{{$t('common.toBeConfirmed')}}({{inviteData['pendingCount']}})</el-radio>
                </el-radio-group>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.invite['1']" :placeholder="$t('reportPlaceholder5')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('invite', 1)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('invite')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportData('invite')" :disabled="total.invite == 0">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="invite1"
                :data="table.invite"
                :total="total.invite"
                :page="currentPage.invite"
                :type="'invite'"
                :pageSize="pagination.pageSize"
                :fields="fields.invite"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitor(scope.data.row.exhibitorEmployeeVO)" type="text" size="small">{{$t('linkVisitor')}}</el-button>
                    <!-- <el-button @click="linkVisitorList(scope.data.row, 'invite', 1)" type="text" size="small">{{$t('visitorList')}}</el-button> -->
                  </template>
                </VisitorData>
          </div>
      </div>

      <!--客商 IM统计-->
      <div class="v-report-block" v-if="false">
        <div class="v-report-title v-clearfix">
          <div class="v-report-text">{{$t('IMStatistics')}}</div>
          <div class="v-report-form">
            <el-date-picker
              size="small"
              v-model="listForm.IM"
              value-format="yyyy-MM-dd HH:mm:ss"
              :start-placeholder="$t('startDate')"
              :end-placeholder="$t('endDate')"
              :picker-options="endDatePicker()"
              @change="dataPickerChange('IM')"
              type="datetimerange">
            </el-date-picker>
          </div>
        </div>
        <div class="v-report-subTitle">{{$t('subTitle5')}}</div>
        <div class="v-report-body v-clearfix">
          <div class="v-report-data" :class="{'on': controlList.IM == 1}" @click="controlTodo('IM', 1, 'IM1')">
            <div class="v-repot-data__title">{{$t('IMNum')}}</div>
            <div class="v-repot-data__subTitle">{{$t('IMNumVisitSub')}}</div>
            <div class="v-repot-data__num">
              <span class="num1">{{modularDateNum.IM['1']}}</span>
              <span class="num2">{{$t('unit5')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="v-report-table" v-loading="loading['IM']">
          <div class="v-report-table__block" v-show="controlList.IM == 1">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="text">{{$t('IMListText')}}
                    <span>{{$t('dataListSubTitle8')}}</span>
                  </div>
                </div>
              </div>
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="searchForm.IM['1']" :placeholder="$t('reportPlaceholder5')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTable('IM', 1)">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <div class="todo-item text" @click="packUp('IM')">{{$t('packUp')}}</div>
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportData('IM')" :disabled="total.IM == 0">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                ref="IM1"
                :type="'IM'"
                :data="table.IM"
                :total="total.IM"
                :page="currentPage.IM"
                :pageSize="pagination.pageSize"
                :fields="fields.invite"
                :showFileds="['interactPersonNum']"
                :hideFileds="['invitePerson', 'status']"
                @sortChange="sortChange"
                @pageChange="pageChange">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="linkVisitorList(scope.data.row, 'IM', 1)" type="text" size="small">{{$t('visitorList')}}</el-button>
                  </template>
                </VisitorData>
          </div>
      </div>

      <!-- 弹框 -->
      <winDialog class='v-report-diag'
        :closeAfter="closeAfter"
        :dialogShow.sync="dialog" 
        :title='dialogTitle' width="80%" >
        <template v-slot:bodyContent>
          <!-- 商贸圈 模块2--->
          <div class='v-report-table__block' v-if="dialogType == 'opportunity' && dialogNum == 2">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="dialogSearch" :placeholder="$t('reportPlaceholder5')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTableDialog">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportDataDialog('opportunity')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :pageSize="pagination.pageSize"
                :fields="fields.dialogOpportunity"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="lookDetail(scope.data.row, 'actor')" type="text" size="small">{{$t('lookDetail')}}</el-button>
                  </template>
                </VisitorData>
          </div>
          <!-- 商贸圈 模块3--->
          <div class='v-report-table__block' v-if="dialogType == 'opportunity' && dialogNum == 3">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="dialogSearch" :placeholder="$t('reportPlaceholder5')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTableDialog">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportDataDialog('opportunity')">{{$t('Export')}}</el-button>
                </div>
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :pageSize="pagination.pageSize"
                :fields="fields.dialogOpportunity"
                :hideFileds="['commentNum']"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="lookDetail(scope.data.row, 'actor')" type="text" size="small">{{$t('lookDetail')}}</el-button>
                  </template>
                </VisitorData>
          </div>
          <!-- 邀约 模块1--->
          <div class='v-report-table__block' v-if="dialogType == 'invite' && dialogNum == 1">
              <!-- <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="dialogSearch" :placeholder="$t('reportPlaceholder5')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTableDialog">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportDataDialog">{{$t('Export')}}</el-button>
                </div>
              </div> -->
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :hideFileds="['collectedNum']"
                :showFileds="['invitePerson', 'status']"
                :fields="fields.visitor"
                :pageSize="pagination.pageSize"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog"
                @linkVisitor="linkVisitor"></VisitorData>
          </div>
          <!-- IM 模块1--->
          <div class='v-report-table__block' v-if="dialogType == 'IM' && dialogNum == 1">
              <div class="report-todo v-clearfix">
                <div class="title v-clearfix">
                  <div class="search-exhibits-wrap">
                    <div class="search-input m-l-0">
                      <el-input v-model="dialogSearch" :placeholder="$t('reportPlaceholder4')" size="mini" clearable></el-input>
                    </div>
                    <el-button size="mini" type="primary" class="search-btn" @click="searchTableDialog">
                      {{$t('common.search')}}</el-button>
                  </div>
                </div>
                <!-- <div class="todo">
                  <el-button icon="el-icon-upload2" type="primary" class="todo-item" size="mini" @click="exportDataDialog">{{$t('Export')}}</el-button>
                </div> -->
              </div>
              <VisitorData
                :data="dialogData"
                :total="dialogTotal"
                :page="dialogPage"
                :pageSize="pagination.pageSize"
                :hideFileds="['visitNum']"
                :fields="fields.dialogIM"
                @sortChange="sortChangeDialog"
                @pageChange="pageChangeDialog">
                  <template slot="todo-action" slot-scope="scope">
                    <el-button @click="lookDetail(scope.data.row, 'actor')" type="text" size="small">{{$t('linkActor')}}</el-button>
                  </template>
                </VisitorData>
          </div>
        </template>
      </winDialog>
      
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VisitorData from '@/components/table/visitorList.vue'
import winDialog from '@/components/dialog/dialog'
import i18n from '@/utils/i18n'
import { 
  collectionCountForVisitor,
  collectionExhibitor,
  collectionProduct,
  
  trailCountForVisitor,
  trailExhibitor,
  trailProduct,
  
  inviteRecordCount,
  inviteRecordExhibitor,

  collectionProductForVisitorExport,
  collectionExhibitorExport,
  trailProductExport,
  trailExhibitorExport,
  inviteRecordExhibitorExport,

  collectionCommercialNumsForVisitor,
  collectionCommercialForVisitor,
  collectionCommercialForVisitorExport,

  collectionCommercialCommentNumsForVisitor,
  collectionCommercialCommentForVisitor,
  collectionCommercialCommentForVisitorExport,
  getExhibitorInfoByCommercialComment,
  getExhibitorInfoByCommercialCommentExport,

  collectionCommercialLikeNumsForVisitor,
  collectionCommercialLikeForVisitor,
  collectionCommercialLikeForVisitorExport,
  getExhibitorInfoByLikeComment,
  getExhibitorInfoByLikeCommentExport,
} from '@/api/statistics'
import { getExhibitorEmployeeList } from '@/api/index'
import { inviteMixin } from '@/mixins/inviteEvent.js'

export default {
  name: 'report',
  components: {
    VisitorData,
    winDialog
  },
  mixins: [inviteMixin],
  data() {
    return {
      pageLoading:false,
      dialog: false,
      dialogTitle: i18n.t('visitorList'),
      dialogData: [],
      dialogType: '',
      dialogNum: 0,
      dialogPage: 1,
      dialogTotal: 0,
      dialogSearch: '',
      dialogFiledSort: [],
      dialogId: '',
      scope: '',
      inviteData: {
        approveCount: 0,
        pendingCount: 0
      },
      // 搜索控件的绑定值
      searchForm: {
        collect: {
          '1': '',
          '2': ''
        },
        browse: {
          '1': '',
          '2': ''
        },
        opportunity: {
          '1': '',
          '2': '',
          '3': ''
        },
        invite: {
          '1': ''
        },
        IM: {
          '1': ''
        }
      },
      // 日期时间选择
      listForm: {
        collect: '',
        browse: '',
        opportunity: '',
        invite: '',
        IM: ''
      },
      controlList: {
        collect: '',
        browse: '',
        opportunity: '',
        invite: '',
        IM: ''
      },
      // 模块数据
      modularDateNum: {
        collect: {
          '1': 0,
          '2': 0
        },
        browse: {
          '1': 0,
          '2': 0
        },
        opportunity: {
          '1': 0,
          '2': 0,
          '3': 0
        },
        invite: {
          '1': 0
        },
        IM: {
          '1': 0
        }
      },
      // loading 状态
      loading: {
        collect: false,
        browse: false,
        opportunity: false,
        invite: false,
        IM: false
      },
      // table 的数据列表
      table: {
        collect: [],
        browse: [],
        opportunity: [],
        invite: [],
        IM: []
      },
      // total 总数居
      total: {
        collect: 0,
        browse: 0,
        opportunity: 0,
        invite: 0,
        IM: 0
      },
      // 一页显示多少条数据
      pagination: {
        pageSize: 10,
      },
      // 字段排序
      fieldSort: {
        actorBase: '',
        product: '',
        opportunity: '',
        invite: '',
        IM: ''
      },
      // 模块的当前页码
      currentPage: {
        collect: 1,
        browse: 1,
        opportunity: 1,
        invite: 1,
        IM: 1
      },
      // table 字段
      fields: {
        'actor': [
          {
            prop: 'name',
            propEn: 'enName',
            label: i18n.t('hActorName'),
            width: 200,
            align: 'center',
          },
          {
            prop: 'exhibitionBoothNumber',
            label: i18n.t('zoomNum'),
            width: 180,
            align: 'center',
          },
          {
            prop: 'countryTitle',
            label: i18n.t('country'),
            //sort: true,
            align: 'center',
          },
          {
            prop: 'provinceTitle',
            label: i18n.t('province'),
            align: 'center',
          },
          {
            prop: 'cityTitle',
            label: i18n.t('city'),
            align: 'center',
          },
          {
            prop: 'status',
            label: i18n.t('hStatus'),
            align: 'center',
            hide: true
          },{
            prop: 'action',
            label: i18n.t('todoAction'),
            align: 'center',
            width: 150
          },
        ],
        'product': [
          {
            prop: 'pdtName',
            propEn: 'pdtEName',
            label: i18n.t('hProductName'),
            align: 'center',
          },
          {
            prop: 'hProductImgVideo',
            label: i18n.t('hProductImgVideo'),
            align: 'center',
            slot: true
          },{
            prop: 'exhibitorName',
            label: i18n.t('hforActor'),
            align: 'center',
          },{
            prop: 'action',
            label: i18n.t('todoAction'),
            align: 'center',
            width: 150
          },
        ],
        'opportunity1': [
          {
            prop: 'content',
            label: i18n.t('oppContent'),
            align: 'center'
          },
          {
            prop: 'url',
            label: i18n.t('oppImgVideo'),
            align: 'center',
            slot: true
          },
          {
            prop: 'commentNum',
            label: i18n.t('numOfcommented'),
            sort: true,
            
            width: 150,
            align: 'center'
          },
          {
            prop: 'likeTotal',
            label: i18n.t('numOfLived'),
            sort: true,
            width: 150,
            align: 'center'
          },
          {
            prop: 'action',
            label: i18n.t('todoAction'),
            width: 150,
            align: 'center'
          }
        ],
        'invite': [
          {
            prop: 'name',
            propEn: 'enName',
            label: i18n.t('hActorName'),
            width: 200,
            align: 'center',
          },
          {
            prop: 'exhibitionBoothNumber',
            label: i18n.t('zoomNum'),
            width: 180,
            align: 'center',
          },
          {
            prop: 'post',
            propEn: 'enPost',
            label: i18n.t('post'),
            align: 'center',
          },
          {
            prop: 'countryTitle',
            label: i18n.t('country'),
            //sort: true,
            align: 'center',
          },
          {
            prop: 'provinceTitle',
            label: i18n.t('province'),
            align: 'center',
          },
          {
            prop: 'cityTitle',
            label: i18n.t('city'),
            align: 'center',
          },
          {
            prop: 'employeeName',
            label: i18n.t('invitePerson'),
            align: 'center',
          },
          {
            prop: 'interactPersonNum',
            label: i18n.t('interactPersonNum'),
            align: 'center',
            hide: true
          },
          {
            prop: 'inviteState',
            label: i18n.t('hStatus'),
            align: 'center',
          },{
            prop: 'action',
            label: i18n.t('todoAction'),
            align: 'center',
            width: 150
          },
        ],
        'dialogOpportunity': [
          {
            prop: 'name',
            propEn: 'enName',
            label: i18n.t('hActorName'),
            width: 200,
            align: 'center',
          },
          {
            prop: 'exhibitionBoothNumber',
            label: i18n.t('zoomNum'),
            width: 180,
            align: 'center',
          },
          {
            prop: 'countryName',
            label: i18n.t('country'),
            sort: true,
            align: 'center',
          },
          {
            prop: 'provinceName',
            label: i18n.t('province'),
            align: 'center',
          },
          {
            prop: 'cityName',
            label: i18n.t('city'),
            align: 'center',
          },
          {
            prop: 'commentNum',
            label: i18n.t('collectedNum'),
            align: 'center',
            sort: true,
          },
          {
            prop: 'likeTotal',
            label: i18n.t('numOfLived'),
            width: 150,
            align: 'center',
            hide: true
          },
          {
            prop: 'action',
            label: i18n.t('todoAction'),
            align: 'center',
            width: 150
          },
        ],
        'dialogIM': [
          {
            prop: 'actorPerson',
            label: i18n.t("actorPerson"),
            align: 'center'
          },
          {
            prop: 'mobile',
            label: i18n.t('mobile'),
            align: 'center'
          },
          {
            prop: 'email',
            label: i18n.t('email'),
            align: 'center'
          },
          {
            prop: 'action',
            label: i18n.t('todoAction'),
            width: 150,
            align: 'center'
          }
        ],
        'visitor': [
          {
            prop: 'name',
            propEn: 'enName',
            label: i18n.t('visitorName'),
            width: 150,
            align: 'center',
          },
          {
            prop: 'corporateName',
            propEn: 'corporateEnName',
            label: i18n.t('companyName'),
            width: 250,
            align: 'center',
          },
          {
            prop: 'post',
            propEn: 'enPost',
            label: i18n.t('post'),
            align: 'center',
          },
          // {
          //   prop: 'countryTitle',
          //   label: i18n.t('country'),
          //   sort: true,
          //   align: 'center',
          // },
          // {
          //   prop: 'provinceTitle',
          //   label: i18n.t('province'),
          //   align: 'center',
          // },
          // {
          //   prop: 'cityTitle',
          //   label: i18n.t('city'),
          //   align: 'center',
          // },
          {
            prop: 'action',
            label: i18n.t('todoAction'),
            type: 'visitorLink',
            align: 'center',
            width: 150
          }
        ]
      },
      endDatePicker() {
        return {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['language', 'subjectType'])
  },
  mounted() {
    this.pageInit()
  },
  methods: {
    // 时间控件change
    dataPickerChange(type) {
      this.modularData(type)
    },
    // 页面初始化
    pageInit() {
      this.pageLoading = true
      this.acount = 0
      this.modularData('collect')
      this.modularData('browse')
      this.modularData('invite')
      this.modularData('opportunity')
      
      let timmer = setInterval(() => {
        if (this.acount == 3) {
          this.pageLoading = false
          clearInterval(timmer)
          timmer = null
        }
      }, 1000)
    },
    // 获取接口请求参数
    getParams(type, level) {
      let startTime = ''
      let endTime = ''
      if (this.listForm[type]) {
        startTime = this.listForm[type][0]
        endTime = this.listForm[type][1]
      }
      if (level == 'data') {
        return {
          startTime,
          endTime
        }
      }

      let params = {
        startTime,
        endTime,
        keyWords: ''
      }
      if (this.searchForm[type] && this.searchForm[type][this.controlList[type]]) {
        params.keyWords = this.searchForm[type][this.controlList[type]]
      }
      if (type == 'invite') {
        params.inviteState = this.scope
      }
      let sortType = 0
      if (this.fieldSort[type].length && level == 'list') {
        let fieldSort = this.fieldSort[type]

        // 点赞
        if (fieldSort[0] == 'likeTotal') {
          sortType = fieldSort[1] === 'descending' ? 4 : 3
        }

        // 评论、点赞
        if (fieldSort[0] == 'commentNum' 
        || (fieldSort[0] == 'likeTotal' && type == 'opportunity' && this.controlList[type] == 3)) {
          sortType = fieldSort[1] === 'descending' ? 2 : 1
        }
      }
      // 列表数据 参数
      if (level == 'list') {
        if (type == 'opportunity') {

          return {
            pageRows: this.pagination.pageSize,
            pageNum: this.currentPage[type],
            start: params.startTime,
            end: params.endTime,
            searchWords: params.keyWords,
            sortType
          }
        }
        return {
          pageSize: this.pagination.pageSize,
          pageIndex: this.currentPage[type],
          ...params
        }
      }

      params.keyWords = this.dialogSearch
      // 弹框参数
      if (this.dialogFiledSort.length) {
        let fieldSort = this.dialogFiledSort
        // 国家排序
        if (fieldSort[0] == 'countryName') {
          sortType = fieldSort[1] === 'descending' ? 4 : 3
        }
        // 国家、评论排序
        if (fieldSort[0] == 'commentNum' 
        || (fieldSort[0] == 'countryName' && type == 'opportunity' && this.controlList[type] == 3)) {
          sortType = fieldSort[1] === 'descending' ? 2 : 1
        }
      }
      if (type == 'opportunity') {
        return {
          pageNum: this.dialogPage,
          pageRows: this.pagination.pageSize,
          start: params.startTime,
          end: params.endTime,
          searchWords: params.keyWords,
          sortType
        }
      }
      return {
        pageSize: this.dialogPage,
        pageIndex: this.pagination.pageSize,
        ...params
      }
    },
    // 模块数据
    modularData(type) {
      let { startTime , endTime } = this.getParams(type, 'data')
      let request = null
      switch(type) {
        // 收藏模块数据
        case 'collect':
          request = collectionCountForVisitor({
            startTime,
            endTime
          }).then(res => {
            return res.data
          }).then(res => {
            if (res.data) {
              this.modularDateNum[type]['1'] = res.data.collectionActorCount
              this.modularDateNum[type]['2'] = res.data.collectionProductCount
            }
          })
          break
        // 浏览模块数据
        case 'browse':
          request = trailCountForVisitor({
            startTime,
            endTime
          }).then(res => {
            return res.data
          }).then(res => {
            if (res.data) {
              this.modularDateNum[type]['1'] = res.data.toActorCount
              this.modularDateNum[type]['2'] = res.data.toProductCount
            }
          })
          break
        // 邀约模块数据
        case 'invite':
          request = inviteRecordCount({
            startTime,
            endTime
          }).then(res => {
            return res.data
          }).then(res => {
            if (res.data) {
              this.modularDateNum[type]['1']  = res.data.approveCount + res.data.pendingCount
              this.inviteData['approveCount'] = res.data.approveCount
              this.inviteData['pendingCount'] = res.data.pendingCount
            } else {
              this.modularDateNum[type]['1']  = 0
              this.inviteData['approveCount'] = 0
              this.inviteData['pendingCount'] = 0
            }
          })
          break
        // 商脉圈模块数据
        case 'opportunity':
          collectionCommercialNumsForVisitor({
            start: startTime,
            end: endTime
          }).then(res => {
            return res.data
          }).then(res => {
            let num = res.data || 0
            this.modularDateNum[type]['1'] = num
          })
          collectionCommercialCommentNumsForVisitor({
            start: startTime,
            end: endTime
          }).then(res => {
            return res.data
          }).then(res => {
            let num = res.data || 0
            this.modularDateNum[type]['2'] = num
          })
          collectionCommercialLikeNumsForVisitor({
            start: startTime,
            end: endTime
          }).then(res => {
            return res.data
          }).then(res => {
            let num = res.data || 0
            this.modularDateNum[type]['3'] = num
          })
          break
      }
      request && request.finally(() => {
        this.acount ++
      })

      if (this.searchForm[type]) {
        Object.keys(this.searchForm[type]).forEach(key => {
          this.searchForm[type][key] = ''
        })
      }
      if (this.controlList[type] != 0) {
        this.baseDataList(type)
      }
    },
    // 模块点击事件
    controlTodo(type, value, refName) {
      if (this.loading[type]) return

      if (this.searchForm[type]) {
        this.searchForm[type][this.controlList[type]] = ''
      }

      if (this.controlList[type] == value) {
        this.controlList[type] = 0
      } else {
        this.$refs[refName] && this.$refs[refName].clearSort()
        this.controlList[type] = value
        this.fieldSort[type] = []
        this.$set(this.currentPage, type, 1)
        this.baseDataList(type, 1)
      } 
    },
    // 模块数据列表
    baseDataList(type, action) {
      // console.log('列表数据', type, this.currentPage[type], this.listForm[type], this.controlList[type], this.fieldSort[type])
      // if (this.searchForm[type]) {
      //   console.log('搜索条件', this.searchForm[type][this.controlList[type]])
      // }
      if (this.modularDateNum[type][this.controlList[type]] == 0 && (this.controlList[type] == 0 || action === 1)) return
      if (this['controlList'][type] == 0) return
      let params = this.getParams(type, 'list')
      let request = null
      let controlListIndex = this.controlList[type]
      switch(type) {
        case 'collect':
          if (controlListIndex == 1) {
            request = collectionExhibitor(params)
          } else if (controlListIndex == 2) {
            request = collectionProduct(params)
          }
          break
        case 'browse':
          if (controlListIndex == 1) {
            request = trailExhibitor(params)
          } else if (controlListIndex == 2) {
            request = trailProduct(params)
          }
          break
        case 'opportunity':
          if (controlListIndex == 1) {
            request = collectionCommercialForVisitor(params)
          } else if (controlListIndex == 2) {
            request = collectionCommercialCommentForVisitor(params)
          } else if (controlListIndex == 3) {
            request = collectionCommercialLikeForVisitor(params)
          }
          break
        case 'invite':
          if (controlListIndex == 1) {
            request = inviteRecordExhibitor(params)
          }
          break
        case 'IM':
          break
      }
      if (request) {
        this.loading[type] = true
        request.then(res => {
          return res.data
        }).then(res => {
          if (!res.data) return
          this.$set(this.table, type, res.data.list)
          this.$set(this.total, type, res.data.total)
        }).finally(() => {
          this.loading[type] = false
        })
      }
    },
    // 邀约状态改变
    stateChange(type, num) {
      this.searchForm[type][num] = ''
      this.pageChange(1, type)
    },
    // 收起
    packUp(type) {
      this.$set(this.controlList, type, 0)
    },
    // 排序
    sortChange(column, prop, order, type) {
      if (order === null) {
        this.fieldSort[type] = []
      } else {
        this.fieldSort[type] = [prop, order]
      }
      this.pageChange(1, type)
    },
    // 分页
    pageChange(page, type) {
      this.$set(this.currentPage, type, page)
      this.baseDataList(type)
    },
    // 导出
    exportData(type) {
      let controlListIndex = this.controlList[type]
      let params = this.getParams(type, 'list')
      let request = null

      switch(type) {
        case 'collect':
          if (controlListIndex == 1) {
            request = collectionExhibitorExport(params)
          } else if (controlListIndex == 2) {
            request = collectionProductForVisitorExport(params)
          }
          break
        case 'browse':
          if (controlListIndex == 1) {
            request = trailExhibitorExport(params)
          } else if (controlListIndex == 2) {
            request = trailProductExport(params)
          }
          break
        case 'opportunity':
          if (controlListIndex == 1) {
            request = collectionCommercialForVisitorExport(params)
          } else if (controlListIndex == 2) {
            request = collectionCommercialCommentForVisitorExport(params)
          } else if (controlListIndex == 3) {
            request = collectionCommercialLikeForVisitorExport(params)
          }
          break
        case 'invite':
          if (controlListIndex == 1) {
            request = inviteRecordExhibitorExport(params)
          }
          break
        case 'IM':
          // if (controlListIndex == 1) {

          // }
          break
      }
      request.then(res => {
        return res.data
      }).then(res => {
        if (res.data) {
          window.open(res.data, '_blank')
        }
      })
    },
    // 搜索按钮点击
    searchTable(type) {
      this.pageChange(1, type)
    },
    // 查看详情
    lookDetail(data, type) {
      this.pageDetail(data, type)
    },
    // 商脉圈展商明细
    opportunityActorList(data, num) {
      let params = this.getParams('opportunity', 'dialog')
      let controlListIndex = this.controlList['opportunity']
      let request = null
      if (controlListIndex == 2){
        request = getExhibitorInfoByCommercialComment({
          ...params,
          commercialDistrictId: data.id
        })
      } else if (controlListIndex == 3) {
        request = getExhibitorInfoByLikeComment({
          ...params,
          commercialDistrictId: data.id
        })
      }
      
      request.then(res => {
        return res.data
      }).then(res => {
        if (res.data) {
          this.diagListResult(res.data, data, 'opportunity', num)
        }
      })
    },
    // 展商明细/客商明细
    linkVisitorList(data, type, num) {
      if (type == 'invite' || type == 'IM') {
        this.dialogTitle = i18n.t('visitorList')
      } else {
        this.dialogTitle = i18n.t('actorListText')
      }

      if (data && data.id) {
        this.dialogId = data.id
        if (type == 'opportunity') {
          this.opportunityActorList(data, num)
        } else {
          getExhibitorEmployeeList({
            pageNum: this.dialogPage,
            pageRows: this.pagination.pageSize,
            exhibitorId: data.id
          }).then(res => {
            return res.data
          }).then(res => {
            if (res.data) {
              this.diagListResult(res.data, data, type, num)
            }
          })
        }
      }
    },
    // 弹框列表
    diagListResult(resData, data, type, num) {
      this.dialogType = type
      num && (this.dialogNum = num)
      this.dialog = true
      let list = resData.list || []
      list.forEach(item => {
        // item.cityTitle = data.cityTitle
        // item.countryTitle = data.countryTitle
        // item.provinceTitle = data.provinceTitle
        item.corporateName = data.name
        item.corporateEnName = data.enName
      });

      this.dialogData = list
      this.dialogTotal = resData.total
    },
    // 弹框搜索按钮点击
    searchTableDialog() {
      this.pageChangeDialog(1)
    },
    // 弹框关闭后
    closeAfter() {
      this.dialogType = ''
      this.dialogNum = 0
      this.dialogPage = 1
      this.dialogTotal = 0
      this.dialogFiledSort = []
      this.dialogSearch = ''
      this.dialogId = ''
    },
    // 弹框导出
    exportDataDialog(type) {
      // let params = this.getParams('opportunity', 'dialog')
      let params = {}
      let controlListIndex = this.controlList[type]
      let request = null

      switch(type) {
        case 'opportunity':
          params = {commercialDistrictId: this.dialogId}
          if (controlListIndex == 2) {
            request = getExhibitorInfoByCommercialCommentExport(params)
          } else if (controlListIndex == 3) {
            request = getExhibitorInfoByLikeCommentExport(params)
          }
          break
      }
      request.then(res => {
        return res.data
      }).then(res => {
        if (res.data) {
          window.open(res.data, '_blank')
        }
      })
    },
    // 弹框表格排序
    sortChangeDialog(column, prop, order) {
      if (order === null) {
        this.dialogFiledSort = []
      } else {
        this.dialogFiledSort = [prop, order]
      }
      this.pageChangeDialog(1)
    },
    // 弹框表格分页
    pageChangeDialog(page) {
      this.dialogPage = page
      this.linkVisitorList({
        id: this.dialogId,
      }, this.dialogType)
    },
    // 联系客商
    linkVisitor(data) {
      this.msgEventPerson({
          id: data.exhibitorId,
          psjName: data.name,
          psjRank: data.post,
          psjComName: data.corporateName || data.corporateEnName,
          easemobAccount: data.easemobAccount
        })
    }
  }
}
</script>

